import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between border-b border-slate-200 px-6 py-4 shrink-0"
};
const _hoisted_2 = {
  id: "official-publisher-manager-title",
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = ["disabled"];
const _hoisted_4 = {
  class: "flex-1 overflow-y-auto px-6 py-4"
};
const _hoisted_5 = {
  key: 0,
  class: "space-y-3"
};
const _hoisted_6 = {
  key: 1,
  class: "py-10 text-center"
};
const _hoisted_7 = {
  key: 2,
  class: "py-10 text-center"
};
const _hoisted_8 = {
  key: 3,
  class: "divide-y divide-slate-100"
};
const _hoisted_9 = ["src", "alt"];
const _hoisted_10 = {
  class: "min-w-0 flex-1"
};
const _hoisted_11 = ["title"];
const _hoisted_12 = {
  class: "text-xs text-slate-400"
};
const _hoisted_13 = ["title"];
const _hoisted_14 = ["checked", "disabled", "onChange"];
const _hoisted_15 = ["disabled", "onClick"];
const _hoisted_16 = ["disabled", "onClick"];
const _hoisted_17 = {
  key: 1,
  class: "space-y-4"
};
const _hoisted_18 = {
  class: "flex items-center gap-3"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  key: 1,
  class: "h-5 w-5 text-slate-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_21 = {
  class: "flex items-center justify-end gap-3 border-t border-slate-200 px-6 py-4 shrink-0"
};
const _hoisted_22 = ["disabled"];
const _hoisted_23 = ["disabled"];
import { computed, nextTick, onBeforeUnmount, reactive, ref, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Delete, Edit } from '@element-plus/icons-vue';
import { createOfficialPublisher, deleteOfficialPublisher, getOfficialPublishers, updateOfficialPublisher, updateOfficialPublisherStatus } from '@/api/circle';
import { uploadFile } from '@/api/file';
import { compressImage } from '@/utils/imageCompress';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'OfficialPublisherManageModal',
  props: {
    show: Boolean
  },
  emits: ['update:show', 'changed'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const dialogRef = ref(null);
    const avatarInput = ref(null);
    const nicknameInput = ref(null);
    const viewMode = ref('list');
    const list = ref([]);
    const loading = ref(false);
    const loadFailed = ref(false);
    const submitting = ref(false);
    const rowLoadingId = ref(null);
    const editingId = ref(null);
    const pendingAvatarFile = ref(null);
    const avatarPreview = ref('');
    const form = reactive({
      nickname: '',
      avatarUrl: '',
      sort: 0
    });
    let previousFocusedElement = null;
    let avatarPreviewIsObjectUrl = false;
    const dialogTitle = computed(() => {
      if (viewMode.value === 'create') return '新增官方发布者';
      if (viewMode.value === 'edit') return '编辑官方发布者';
      return '管理官方发布者';
    });
    watch(() => props.show, async val => {
      if (val) {
        previousFocusedElement = document.activeElement;
        viewMode.value = 'list';
        resetFormState();
        await loadList();
        await nextTick();
        dialogRef.value?.focus();
      } else {
        releaseAvatarPreview();
      }
    });
    const loadList = async () => {
      loading.value = true;
      loadFailed.value = false;
      try {
        const data = await getOfficialPublishers();
        list.value = Array.isArray(data) ? data : [];
      } catch {
        list.value = [];
        loadFailed.value = true;
      } finally {
        loading.value = false;
      }
    };
    const releaseAvatarPreview = () => {
      if (avatarPreviewIsObjectUrl && avatarPreview.value) {
        URL.revokeObjectURL(avatarPreview.value);
      }
      avatarPreviewIsObjectUrl = false;
      avatarPreview.value = '';
    };
    const resetFormState = () => {
      form.nickname = '';
      form.avatarUrl = '';
      form.sort = 0;
      editingId.value = null;
      pendingAvatarFile.value = null;
      releaseAvatarPreview();
    };
    const handleCreate = () => {
      resetFormState();
      viewMode.value = 'create';
    };
    const handleEdit = item => {
      resetFormState();
      form.nickname = item.nickname;
      form.avatarUrl = item.avatarUrl;
      form.sort = item.sort ?? 0;
      avatarPreview.value = item.avatarUrl;
      editingId.value = item.id;
      viewMode.value = 'edit';
    };
    const handleCancelForm = () => {
      if (submitting.value) return;
      resetFormState();
      viewMode.value = 'list';
    };
    const handleAvatarChange = async event => {
      const file = event.target.files[0];
      if (!file) return;
      if (!file.type.startsWith('image/')) {
        ElMessage.warning('请选择图片文件');
        return;
      }
      const compressed = await compressImage(file);
      pendingAvatarFile.value = compressed;
      releaseAvatarPreview();
      avatarPreview.value = URL.createObjectURL(compressed);
      avatarPreviewIsObjectUrl = true;
      event.target.value = '';
    };
    const handleSave = async () => {
      if (submitting.value) return;
      const nickname = form.nickname.trim();
      if (!nickname) {
        ElMessage.warning('发布者昵称不能为空');
        nicknameInput.value?.focus();
        return;
      }
      if (nickname.length > 50) {
        ElMessage.warning('发布者昵称长度不能超过50个字符');
        nicknameInput.value?.focus();
        return;
      }
      const sort = form.sort === '' || form.sort == null ? 0 : Number(form.sort);
      if (!Number.isInteger(sort) || sort < 0) {
        ElMessage.warning('排序值不能小于0');
        return;
      }
      submitting.value = true;
      try {
        // 先上传头像，成功后才调用新增或更新接口；上传失败保留表单和本地预览
        let avatarUrl = form.avatarUrl.trim();
        if (pendingAvatarFile.value) {
          const result = await uploadFile(pendingAvatarFile.value, 'circle', 'public');
          avatarUrl = result.url || result;
        }
        if (!avatarUrl) {
          ElMessage.warning('请上传发布者头像');
          return;
        }
        if (avatarUrl.length > 500) {
          ElMessage.warning('发布者头像长度不能超过500个字符');
          return;
        }
        const payload = {
          nickname,
          avatarUrl,
          sort
        };
        if (viewMode.value === 'edit') {
          await updateOfficialPublisher(editingId.value, payload);
        } else {
          await createOfficialPublisher(payload);
        }
        ElMessage.success('保存成功');
        emit('changed');
        resetFormState();
        viewMode.value = 'list';
        await loadList();
      } catch (error) {
        ElMessage.error(error.message || '保存失败');
        if (error.message && error.message.includes('昵称')) {
          nicknameInput.value?.focus();
        }
      } finally {
        submitting.value = false;
      }
    };
    const handleStatus = async item => {
      const targetStatus = item.status === 1 ? 0 : 1;
      rowLoadingId.value = item.id;
      try {
        await updateOfficialPublisherStatus(item.id, {
          status: targetStatus
        });
        ElMessage.success(targetStatus === 1 ? '已启用' : '已停用');
        emit('changed');
        await loadList();
      } catch (error) {
        ElMessage.error(error.message || '状态更新失败');
      } finally {
        rowLoadingId.value = null;
      }
    };
    const handleDelete = async item => {
      try {
        await ElMessageBox.confirm(`删除后历史动态仍展示原有昵称和头像，确认删除发布者“${item.nickname}”吗？`, '删除官方发布者', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        });
      } catch {
        return;
      }
      rowLoadingId.value = item.id;
      try {
        await deleteOfficialPublisher(item.id);
        ElMessage.success('删除成功');
        emit('changed');
        await loadList();
      } catch (error) {
        ElMessage.error(error.message || '删除失败');
      } finally {
        rowLoadingId.value = null;
      }
    };
    const handleClose = () => {
      if (submitting.value) return;
      emit('update:show', false);
      if (previousFocusedElement && typeof previousFocusedElement.focus === 'function') {
        previousFocusedElement.focus();
      }
      previousFocusedElement = null;
    };

    // AppModal 统一走 close 事件（Esc/关闭按钮）：表单视图先返回列表，列表视图才关闭弹窗
    const handleModalClose = () => {
      if (viewMode.value === 'list') {
        handleClose();
      } else {
        handleCancelForm();
      }
    };

    // 键盘焦点约束：Escape 返回/关闭，Tab 在弹窗内循环
    const handleDialogKeydown = event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        if (viewMode.value === 'list') {
          handleClose();
        } else {
          handleCancelForm();
        }
        return;
      }
      if (event.key !== 'Tab') return;
      const root = dialogRef.value;
      if (!root) return;
      const selectors = ['button:not([disabled])', 'input:not([disabled])', '[tabindex]:not([tabindex="-1"])'].join(',');
      const focusable = Array.from(root.querySelectorAll(selectors)).filter(el => el.offsetParent !== null);
      if (focusable.length === 0) {
        event.preventDefault();
        root.focus();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;
      if (event.shiftKey && (active === first || !root.contains(active))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (active === last || !root.contains(active))) {
        event.preventDefault();
        first.focus();
      }
    };
    onBeforeUnmount(() => {
      releaseAvatarPreview();
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: __props.show,
          size: "2xl",
          "panel-class": "max-h-[calc(100vh-2rem)]",
          "z-index": 60,
          scrollable: false,
          "close-on-overlay": false,
          onClose: handleModalClose
        }, {
          default: _withCtx(() => [_createElementVNode("section", {
            ref_key: "dialogRef",
            ref: dialogRef,
            tabindex: "-1",
            class: "flex max-h-[calc(100vh-2rem)] w-full flex-col",
            onKeydown: handleDialogKeydown
          }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(dialogTitle.value), 1), _createElementVNode("button", {
            type: "button",
            title: "关闭",
            "aria-label": "关闭官方发布者管理",
            disabled: submitting.value,
            class: "rounded-lg p-2 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600 disabled:opacity-50",
            onClick: handleClose
          }, [...(_cache[3] || (_cache[3] = [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))], 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [viewMode.value === 'list' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, index => {
            return _createElementVNode("div", {
              key: index,
              class: "h-14 animate-pulse rounded-lg bg-slate-50"
            });
          }), 64))])) : loadFailed.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_cache[4] || (_cache[4] = _createElementVNode("p", {
            class: "text-sm text-slate-500"
          }, "官方发布者列表加载失败", -1)), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary mt-4",
            onClick: loadList
          }, "重试")])) : list.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[5] || (_cache[5] = [_createElementVNode("p", {
            class: "empty-state-title"
          }, "暂无官方发布者，点击下方按钮新增", -1)]))])) : (_openBlock(), _createElementBlock("ul", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, item => {
            return _openBlock(), _createElementBlock("li", {
              key: item.id,
              class: "flex items-center gap-3 py-3"
            }, [_createElementVNode("img", {
              src: item.avatarUrl,
              alt: item.nickname,
              class: "h-10 w-10 shrink-0 rounded-full object-cover"
            }, null, 8, _hoisted_9), _createElementVNode("div", _hoisted_10, [_createElementVNode("p", {
              class: "truncate text-sm font-medium text-slate-800",
              title: item.nickname
            }, _toDisplayString(item.nickname), 9, _hoisted_11), _createElementVNode("p", _hoisted_12, "排序 " + _toDisplayString(item.sort), 1)]), _createElementVNode("label", {
              class: "form-switch",
              title: item.status === 1 ? '点击停用' : '点击启用'
            }, [_createElementVNode("input", {
              type: "checkbox",
              class: "form-switch-input",
              checked: item.status === 1,
              disabled: rowLoadingId.value === item.id,
              onChange: $event => handleStatus(item)
            }, null, 40, _hoisted_14), _cache[6] || (_cache[6] = _createElementVNode("span", {
              class: "form-switch-track"
            }, null, -1))], 8, _hoisted_13), _createElementVNode("button", {
              type: "button",
              class: "table-action-button is-primary",
              title: "编辑",
              "aria-label": "编辑",
              disabled: rowLoadingId.value === item.id,
              onClick: $event => handleEdit(item)
            }, [_createVNode(_component_el_icon, {
              size: 16
            }, {
              default: _withCtx(() => [_createVNode(_unref(Edit))]),
              _: 1
            })], 8, _hoisted_15), _createElementVNode("button", {
              type: "button",
              class: "table-action-button is-danger",
              title: "删除",
              "aria-label": "删除",
              disabled: rowLoadingId.value === item.id,
              onClick: $event => handleDelete(item)
            }, [_createVNode(_component_el_icon, {
              size: 16
            }, {
              default: _withCtx(() => [_createVNode(_unref(Delete))]),
              _: 1
            })], 8, _hoisted_16)]);
          }), 128))]))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", null, [_cache[7] || (_cache[7] = _createElementVNode("label", {
            class: "mb-1 block text-sm font-medium text-slate-700"
          }, [_createTextVNode(" 昵称 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            ref_key: "nicknameInput",
            ref: nicknameInput,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.nickname = $event),
            type: "text",
            maxlength: "50",
            placeholder: "如：品牌官方",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, form.nickname]])]), _createElementVNode("div", null, [_cache[10] || (_cache[10] = _createElementVNode("label", {
            class: "mb-1 block text-sm font-medium text-slate-700"
          }, [_createTextVNode(" 头像 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createElementVNode("div", _hoisted_18, [_createElementVNode("button", {
            type: "button",
            title: "上传头像",
            class: "flex h-12 w-12 shrink-0 cursor-pointer items-center justify-center overflow-hidden rounded-full border-2 border-dashed border-slate-300 transition-colors hover:border-primary-400",
            onClick: _cache[1] || (_cache[1] = $event => avatarInput.value?.click())
          }, [avatarPreview.value ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: avatarPreview.value,
            class: "h-full w-full object-cover"
          }, null, 8, _hoisted_19)) : (_openBlock(), _createElementBlock("svg", _hoisted_20, [...(_cache[8] || (_cache[8] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          }, null, -1)]))]))]), _cache[9] || (_cache[9] = _createElementVNode("span", {
            class: "text-xs text-slate-400"
          }, "点击上传头像，保存时才会提交", -1))]), _createElementVNode("input", {
            ref_key: "avatarInput",
            ref: avatarInput,
            type: "file",
            accept: "image/*",
            class: "hidden",
            onChange: handleAvatarChange
          }, null, 544)]), _createElementVNode("div", null, [_cache[11] || (_cache[11] = _createElementVNode("label", {
            class: "mb-1 block text-sm font-medium text-slate-700"
          }, "排序值（越小越靠前）", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.sort = $event),
            type: "number",
            min: "0",
            step: "1",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, form.sort]])])]))]), _createElementVNode("div", _hoisted_21, [viewMode.value === 'list' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: handleClose
          }, "关闭"), _createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: handleCreate
          }, "新增发布者")], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: submitting.value,
            onClick: handleCancelForm
          }, "取消", 8, _hoisted_22), _createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            disabled: submitting.value,
            onClick: handleSave
          }, _toDisplayString(submitting.value ? '保存中...' : '保存'), 9, _hoisted_23)], 64))])], 544)]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })]);
    };
  }
};